import * as actionTypes from './actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    isFilters: false,
    categories: null,
    dates: {
        startDate: null,
        endDate: null,
    },
    additional: {
        companies: null,
        persons: null,
        regions: null,
        sources: null,
        tonality: null,
        subjectivity: null,
    },
    search: null,
};

// Проверяет наличие фильтров на основе стэйта, возвращает bool
const computeIsFilters = (state) => {
    return !!(
        state.categories ||
        state.dates.startDate ||
        state.dates.endDate ||
        state.search ||
        state.additional.companies ||
        state.additional.persons ||
        state.additional.regions ||
        state.additional.sources ||
        state.additional.tonality ||
        state.additional.subjectivity
    );
};

// Удаляет элементы списка, возвращает новый список без удаленного элемента
// когда список становится пустым, возвращает null. Чистая функция.
// action берет из замыкания
const deleteItemFromList = (list, conditionCallback) => {
    // conditionCallback - колбек для сравнения элементов списка
    try {
        const itemToDeleteIndex = typeof list === 'object' && list.findIndex(conditionCallback);

        let updatedList = [];
        if (itemToDeleteIndex !== -1) {
            // https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
            updatedList = [...list];
            updatedList.splice(itemToDeleteIndex, 1);
        }
        return updatedList && updatedList.length ? updatedList : null;
    } catch (err) {
        console.error(err.errorMessage);
    }
};

// переменная для промежуточного добавления обновленного state
// для корректного пересчета свойства isFilters
let updatedState = initialState;

export const allNewsFiltersReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ALL_NEWS_APPLY_CATEGORIES_FILTER:
            return {
                ...state,
                categories: action.categories,
                isFilters: true,
            };
        case actionTypes.ALL_NEWS_REMOVE_CATEGORY_FROM_FILTER:
            const listUpdatedCategories = deleteItemFromList(state.categories, (item) => item.id === action.id);
            updatedState = {
                ...state,
                categories: listUpdatedCategories,
            };
            return {
                ...updatedState,
                isFilters:
                    listUpdatedCategories || computeIsFilters(updatedState) ? computeIsFilters(updatedState) : false,
            };
        case actionTypes.ALL_NEWS_REMOVE_CATEGORIES_FILTER:
            updatedState = {
                ...state,
                categories: null,
            };
            return {
                ...updatedState,
                isFilters: computeIsFilters(updatedState),
            };
        case actionTypes.ALL_NEWS_APPLY_DATES_RANGE_FILTER:
            return {
                ...state,
                dates: {
                    startDate: action.startDate,
                    endDate: action.endDate,
                },
                isFilters: true,
            };
        case actionTypes.ALL_NEWS_REMOVE_DATES_RANGE_FILTER:
            updatedState = {
                ...state,
                dates: {
                    startDate: null,
                    endDate: null,
                },
            };
            return {
                ...updatedState,
                isFilters: computeIsFilters(updatedState),
            };
        case actionTypes.ALL_NEWS_APPLY_SEARCH_FILTER:
            return {
                ...state,
                search: action.text,
                isFilters: true,
            };
        case actionTypes.ALL_NEWS_REMOVE_SEARCH_FILTER:
            updatedState = {
                ...state,
                search: '',
            };
            return {
                ...updatedState,
                isFilters: computeIsFilters(updatedState),
            };
        case actionTypes.ALL_NEWS_REMOVE_SEARCH_ITEM:
            const listUpdatedSearchItems = deleteItemFromList(state.search, (item) => item === action.itemName);
            updatedState = {
                ...state,
                search: listUpdatedSearchItems,
            };
            return {
                ...updatedState,
                isFilters:
                    listUpdatedSearchItems || computeIsFilters(updatedState) ? computeIsFilters(updatedState) : false,
            };
        case actionTypes.ALL_NEWS_APPLY_ADDITIONAL_FILTER:
            return {
                ...state,
                additional: action.additionalFilterData,
                isFilters: true,
            };
        case actionTypes.ALL_NEWS_REMOVE_ADDITIONAL_FILTER:
            updatedState = {
                ...state,
                additional: {
                    companies: null,
                    persons: null,
                    regions: null,
                    sources: null,
                    tonality: null,
                },
            };
            return {
                ...updatedState,
                isFilters: computeIsFilters(updatedState),
            };
        case actionTypes.ALL_NEWS_REMOVE_COMPANY_FROM_FILTER:
            const listUpdatedCompany = deleteItemFromList(state.additional.companies, (item) => item.id === action.id);
            updatedState = {
                ...state,
                additional: {
                    ...state.additional,
                    companies: listUpdatedCompany,
                },
            };
            return {
                ...updatedState,
                isFilters:
                    listUpdatedCompany || computeIsFilters(updatedState) ? computeIsFilters(updatedState) : false,
            };
        case actionTypes.ALL_NEWS_REMOVE_PERSON_FROM_FILTER:
            const listUpdatedPersons = deleteItemFromList(state.additional.persons, (item) => item.id === action.id);
            updatedState = {
                ...state,
                additional: {
                    ...state.additional,
                    persons: listUpdatedPersons,
                },
            };
            return {
                ...updatedState,
                isFilters:
                    listUpdatedPersons || computeIsFilters(updatedState) ? computeIsFilters(updatedState) : false,
            };
        case actionTypes.ALL_NEWS_REMOVE_REGION_FROM_FILTER:
            const listUpdatedRegions = deleteItemFromList(state.additional.regions, (item) => item.id === action.id);
            updatedState = {
                ...state,
                additional: {
                    ...state.additional,
                    regions: listUpdatedRegions,
                },
            };
            return {
                ...updatedState,
                isFilters:
                    listUpdatedRegions || computeIsFilters(updatedState) ? computeIsFilters(updatedState) : false,
            };
        case actionTypes.ALL_NEWS_REMOVE_SOURCE_FROM_FILTER:
            const listUpdatedSources = deleteItemFromList(state.additional.sources, (item) => item.id === action.id);
            updatedState = {
                ...state,
                additional: {
                    ...state.additional,
                    sources: listUpdatedSources,
                },
            };
            return {
                ...updatedState,
                isFilters:
                    listUpdatedSources || computeIsFilters(updatedState) ? computeIsFilters(updatedState) : false,
            };
        case actionTypes.ALL_NEWS_REMOVE_TONALITY_FROM_FILTER:
            updatedState = {
                ...state,
                additional: {
                    ...state.additional,
                    tonality: null,
                },
            };
            return {
                ...updatedState,
                isFilters: computeIsFilters(updatedState),
            };

        case actionTypes.ALL_NEWS_REMOVE_SUBJECTIVITY_FROM_FILTER:
            updatedState = {
                ...state,
                additional: {
                    ...state.additional,
                    subjectivity: null,
                },
            };
            return {
                ...updatedState,
                isFilters: computeIsFilters(updatedState),
            };

        case actionTypes.ALL_NEWS_REMOVE_ALL_FILTERS:
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/allNewsFilters/reducer.js